function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Pendulum-wordmark",
  fill: "#2C3131"
}, /*#__PURE__*/React.createElement("path", {
  d: "M69,0 C107.108,0 138,30.892 138,69 C138,107.108 107.108,138 69,138 C30.892,138 0,107.108 0,69 C0,30.892 30.892,0 69,0 Z M69,13.543 C38.372,13.543 13.543,38.373 13.543,69 C13.543,99.628 38.373,124.457 69,124.457 C99.628,124.457 124.457,99.627 124.457,69 C124.457,38.372 99.627,13.543 69,13.543 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "79.737 27.325 92.157 32.725 58.263 110.675 45.843 105.275"
})));

function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "138px",
    height: "138px",
    viewBox: "0 0 138 138",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pendulum-wordmark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9f58ddcc45f3234387cdf6f644ed95a9.svg";
export { ForwardRef as ReactComponent };